import {AfterViewInit, Component} from '@angular/core';
import {OauthService} from '../../shared/services/oauth.service';
import {App} from 'ionic-angular';
import {LocalStorageService} from '../../shared/services/localStorage.service';
import {Config} from '../../shared/services/config.service';
import {SessionStorageService} from '../../shared/services/sessionStorage.service';
import {BeneficiaireContextService, PlatformContextService} from '../../shared';
import {ToastDirective} from '../../shared/directives/toast/toast';
import {DomSanitizer} from '@angular/platform-browser';
import {EnvironnementProvider} from '../app/environnement-provider.service';
import {AppProvider} from '../app/app-provider.service';
import { MenuService } from '../../shared/services/menu.service';

@Component({
  selector: 'core-main-menu',
  templateUrl: './main-menu.component.html',
})
export class MainMenuComponent {
  private menu: any = [];
  public filters = {};
  public buildInfo;
  public buildInfoSummary;

  constructor(
    private oauthService: OauthService,
    public app: App,
    public readonly config: Config,
    private platformContextService: PlatformContextService,
    private beneficiaireContext: BeneficiaireContextService,
    private lsService: LocalStorageService,
    private ssService: SessionStorageService,
    private toast: ToastDirective,
    private sanitize: DomSanitizer,
    private environnementProvider: EnvironnementProvider,
    private appProvider: AppProvider,
    private readonly menuService: MenuService,
  ) {

    const appMode = this.platformContextService.getPlatformContext();
    this.buildInfo = {
      version: this.appProvider.version,
      app: this.config.getConfig('app'),
      apiUrl: this.environnementProvider.default.apiUrl,
      client_id: this.environnementProvider.default.client_id,
      environnement: this.environnementProvider.defaultName()
    };

    this.initMenu(appMode);
  }

  initMenu(appMode) {

    // Si le menu est vide
    // OU si la date d'enregistrement du menu est vide
    // Ou qu'elle date de plus d'un jour
    // => on recharge le menu
    if (this.needReloadMenu()) {
      this.menuService.init().subscribe(resp => {
        this.menuService.saveSession(resp);
        this.loadMenu(appMode);
      })
    }
    else { // Menu en session
      this.loadMenu(appMode);
    }
  }

  needReloadMenu(): boolean {
    if (!this.ssService.getDateMenu()) {
      return true;
    }
    let dateSession = new Date(this.ssService.getDateMenu());
    let dateMaxSession: Date = new Date();
    dateMaxSession.setDate(dateMaxSession.getDate() - 1);
    return (dateSession < dateMaxSession);
  }

  loadMenu(appMode: any) {
    this.menu = this.ssService.getMenu()
      .filter(menuItem => this.checkPermissions(menuItem, appMode))
      .map(menuItem => this.checkChildrenPermissions(menuItem, appMode));
  }

  showBuildInfo() {
    this.buildInfoSummary = this.sanitize.bypassSecurityTrustHtml(
      Object.keys(this.buildInfo).map((key) => [key, this.buildInfo[key]].join('=>'))
        .join(`<br/>`)
    );
  }

  checkPermissions(menuItem, appMode) {
    return menuItem.group.indexOf(appMode) !== -1;
  }

  checkChildrenPermissions(menuItem, appMode) {
    if (menuItem.children) {
      menuItem.children = menuItem.children.filter(menuItemChild =>
        this.checkPermissions(menuItemChild, appMode)
      );
    }
    return menuItem;
  }

  // hydrateMenu() {
  //   return [
  //     {
  //       label: 'Accueil',
  //       action: 'onUserBoard',
  //       ionIcon: 'home',
  //       group: ['salarie']
  //     },
  //     {
  //       label: 'Gestion des bénéficiaires',
  //       action: 'onBeneficiaireList',
  //       glyph: 'glyph_group',
  //       group: ['elu']
  //     },
  //     {
  //       label: 'Mon profil',
  //       action: 'onBeneficiairePage',
  //       glyph: 'glyph_group',
  //       group: ['salarie'],
  //       hideWeb: true
  //     },
  //     {
  //       label: 'Activités',
  //       action: 'onCatalogueList',
  //       ionIcon: 'ekipea-cart',
  //       group: ['elu', 'salarie']
  //     },
  //     {
  //       label: 'Historique commandes',
  //       action: 'onCommandList',
  //       glyph: 'glyph_stats',
  //       group: ['elu']
  //     },
  //     {
  //       label: 'Historique remboursements',
  //       action: 'onFolderList',
  //       glyph: 'glyph_stats',
  //       group: ['elu']
  //     },
  //     {
  //       label: 'Suivi des stocks',
  //       action: 'onStockList',
  //       glyph: 'glyph_task-list',
  //       group: ['elu']
  //     },
  //     {
  //       label: 'Historique subventions',
  //       action: 'onSubventionList',
  //       glyph: 'glyph_stats',
  //       group: ['elu']
  //     },
  //     {
  //       label: 'Attribution manuelle',
  //       action: 'onClickAddEnveloppe',
  //       glyph: 'glyph_task-list',
  //       group: ['elu']
  //     },
  //     {
  //       label: 'Requêtes',
  //       action: 'onClickQueryList',
  //       glyph: 'glyph_stats',
  //       group: ['elu']
  //     },
  //     {
  //       label: 'Encaissements en attente',
  //       action: 'onPaymentList',
  //       glyph: 'glyph_chat',
  //       group: []
  //     },
  //     {
  //       label: 'Sondages',
  //       action: 'onClickSondageList',
  //       ionIcon: 'stats',
  //       group: ['salarie']
  //     },
  //     {
  //       label: 'Le BLOG\'INFO',
  //       action: 'onClickBlogArticleList',
  //       ionIcon: 'ekipea-megaphone',
  //       group: ['salarie']
  //     },
  //     {
  //       label: 'Les codes promos',
  //       action: 'onClickPromoArticleList',
  //       ionIcon: 'ekipea-promo',
  //       group: ['salarie']
  //     },
  //     {
  //       label: 'Edito',
  //       action: 'onClickEditoArticleList',
  //       ionIcon: 'ekipea-chat',
  //       group: ['salarie']
  //     },
  //     {
  //       label: 'Infos Pratiques',
  //       action: 'onSoon',
  //       ionIcon: 'ekipea-infos',
  //       group: ['salarie'],
  //       children: [
  //         {label: 'Sondage', action: 'onSoon', group: []},
  //         {label: 'Pv du CE', action: 'onSoon', group: []},
  //         {label: 'Vos Elus', action: 'onSoon', group: []},
  //         {label: 'Votre Comité', action: 'onClickInfosArticleList', group: ['salarie']},
  //         {label: 'Vos élus', action: 'onClickElusArticleList', group: ['salarie']},
  //         {label: 'Les PV de réunion', action: 'onClickPVArticleList', group: ['salarie']},
  //         {label: 'Mentions légales', action: 'onClickLegalArticleList', group: ['salarie']},
  //       ]
  //     },
  //     {
  //       label: 'Déconnexion',
  //       action: 'onLogOut',
  //       glyph: 'glyph_exit',
  //       group: ['elu', 'salarie'],
  //       hideWeb: true
  //     }
  //   ];
  // }

  onSoon() {
  }

  onBeneficiaireList(menuName) {
    this.app.getRootNav().setRoot('BeneficiaireListPage', {pageTitle: 'Choix bénéficiaires'});
  }

  onBeneficiairePage(menuPage) {
    const beneficiaire = this.beneficiaireContext.get();
    if (null !== beneficiaire) {
      this.app.getActiveNav().push('BeneficiairePage', {'beneficiaire': beneficiaire.id, 'tab': 'benef-card', 'pageTitle':menuPage}); // link to benef
    }
  }

  onCatalogueList(menuName) {
    this.app.getRootNav().setRoot('CategoriesPage', {pageTitle: menuName});
  }

  onCommandList(menuName) {
    this.app.getRootNav().setRoot('CommandListPage', {pageTitle: menuName});
  }

  onFolderList(menuName) {
    this.app.getRootNav().setRoot('FolderListPage', {pageTitle: menuName});
  }

  onStockList(menuName) {
    this.app.getRootNav().setRoot('StockListPage', {pageTitle: menuName});
  }

  onSubventionList(menuName) {
    this.app.getRootNav().setRoot('SubventionListPage', {pageTitle: menuName});
  }

  onPaymentList(menuName) {
    this.app.getRootNav().setRoot('PaymentListPage', {pageTitle: menuName});
  }

  onClickAddEnveloppe(menuName) {
    this.app.getRootNav().setRoot('BeneficiaireEnveloppePage', {pageTitle: menuName});
  }

  onClickQueryList(menuName) {
    this.app.getRootNav().setRoot('QueryListPage', {pageTitle: menuName});
  }

  onClickBlogArticleList(menuName) {
    this.goToBlogArticleList('BLOG', menuName);
  }

  goToBlogArticleList(type, menuName) {
    this.ssService.removeBlogArticleFilters();
    this.filters = {
      themeFilters: [],
      myDateStart: '',
      myDateEnd: '',
      orderBy: 'date',
      order: 'DESC',
      type: type
    };
    this.app
      .getRootNav()
      .setRoot('BlogArticleListPage', {filters: this.filters, start: 1, pageTitle: menuName});
  }

  onClickPromoArticleList(menuName) {
    this.goToBlogArticleList('PROMO', menuName);
  }

  onClickEditoArticleList(menuName) {
    this.goToBlogArticleList('EDITO', menuName);
  }

  onClickInfosArticleList(menuName) {
    this.goToBlogArticleList('INFO', menuName);
  }

  onClickLegalArticleList(menuName) {
    this.goToBlogArticleList('LEGAL', menuName);
  }

  onClickPVArticleList(menuName) {
    this.goToBlogArticleList('PV_CE', menuName);
  }

  onClickElusArticleList(menuName) {
    this.app.getRootNav().setRoot('BlogEluListPage', {pageTitle: menuName});
  }

  onLogOut() {
    this.oauthService.logOut(this.app);
  }

  onUserBoard(menuName) {
    this.app.getRootNav().setRoot('UserBoardPage', {pageTitle: menuName});
  }

  onClickSondageList(menuName) {
    this.app.getRootNav().setRoot('SondageListPage', {pageTitle: menuName});
  }

  onNotifPage(menuName) {
    this.app.getRootNav().setRoot('NotificationPage', {pageTitle: menuName});
  }
}



// WEBPACK FOOTER //
// ./src/core/main-menu/main-menu.component.ts